import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import format from "date-fns/format";

import * as codeActions from "../../../actions/codeActions";
import * as contractActions from "../../../actions/contractActions";

import DropdownSearch from "../../common/DropdownSearch";
import UserSelect from "../../common/UserSelect";
import Loading from "../../common/Loading";

import ReportFilters from "../ReportFiltersComponent";
import { downloadCSV } from "../utils";

import columns from "./ActiveContracts.columns";

function ActiveContracts({ loading, actions, codes, contracts }) {
  const [filters, setFilters] = useState({
    salesperson: [],
    contract_type: []
  });

  const handleFetchClick = () => {
    const query = {};
    if (filters.salesperson.length) {
      query.salesperson = filters.salesperson.map((s) => s.value);
    }
    if (filters.contract_type) {
      query.contract_type = filters.contract_type.map((s) => s.value);
    }
    actions.loadActiveContracts(query);
  };

  const handleResetClick = () => {
    setFilters({
      salesperson: [],
      contract_type: []
    });
    actions.clearContracts();
  };

  const handleCSVExportClick = () => {
    downloadCSV(
      `IrisContracts-${format(new Date(), "yyyy_MM_dd")}`,
      contracts,
      columns
    );
  };

  const handleChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      .filter((code) => code.entity === entity && code.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));
    return orderBy(
      codeOptions,
      [(option) => option.label.toLowerCase()],
      "order"
    );
  };

  return (
    <React.Fragment>
      <ReportFilters
        onFetchClick={handleFetchClick}
        onResetClick={handleResetClick}
        title="Active Contracts"
        loading={loading}
        disabled={loading}
        csvExportAvailable
        onCSVExport={handleCSVExportClick}
        exportDisabled={loading || !contracts.length}
      >
        <Row>
          <Col md={6}>
            <UserSelect
              isMulti
              label="Salesperson"
              placeholder="Select"
              value={filters.salesperson || []}
              onChange={(e) => handleChange("salesperson", e)}
            />
          </Col>
          <Col md={6}>
            <DropdownSearch
              isMulti
              rowStyles={{ marginTop: 0 }}
              label="Contract Type"
              placeholder="Select"
              name="contract_type"
              onChange={(field, value) => handleChange(field, value)}
              value={filters.contract_type || []}
              data={generateCodeOptions("Contract", "type")}
            />
          </Col>
        </Row>
      </ReportFilters>
      <Row>
        <div
          className="content-wrapper"
          style={{ padding: "15px 15px ", borderRadius: "0.5rem" }}
        >
          <ReactTable
            loading={loading}
            LoadingComponent={() => <Loading active={loading} />}
            columns={columns}
            data={contracts}
            defaultPageSize={10}
            noDataText="No Contracts Found"
          />
        </div>
      </Row>
    </React.Fragment>
  );
}

ActiveContracts.propTypes = {
  codes: PropTypes.array,
  contracts: PropTypes.array,
  loading: PropTypes.bool,
  actions: PropTypes.object
};

ActiveContracts.defaultProps = {
  codes: [],
  contracts: []
};

const mapStatesToProps = (state) => ({
  codes: state.reducers.codes,
  contracts: state.reducers.contracts,
  loading: state.reducers.loading
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...codeActions,
      ...contractActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(ActiveContracts);
